"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.aiFormAnalyzer.name': 'KI-Formularanalyse',
    'tools.aiFormAnalyzer.formSentByUser': 'Ich habe das Formular abgeschickt.',
};
